import React from 'react'
import { FormattedMessage } from 'react-intl'
import BillingSetup from '../../BillingSetup'

export default function PaymentMethodSelect({
  state,
  onPaymentMethodSelect,
  onGoToStep
}) {
  return (
    <div className='workspace-plan-step'>
      <div className='workspace-plan-step-head'>
        <div>
          <button
            onClick={onGoToStep(1)}
            className='back-button'
          >
            <FormattedMessage id='BACK' />
          </button>
        </div>
        <div>
          <h2 className='title'>
            <FormattedMessage id='CHOOSE_PAYMENT_METHOD' />
          </h2>
        </div>
        {state.selectedPlan && state.selectedPaymentMethod && (
          <div>
            <button
              onClick={onGoToStep(3)}
              className='next-button'
            >
              <FormattedMessage id='NEXT' />
            </button>
          </div>
        )}
      </div>
      <div className='workspace-plan-step-body'>
        <BillingSetup
          state={state}
          mode='select'
          onPaymentMethodSelect={onPaymentMethodSelect}
        />
      </div>
    </div>
  )
}
